import React from 'react'

const sponsorsData = {
    "sponsors": [
        {
            "name": "BTW UK",
            "image": "images/sponsors/btw-uk.png",
            "description": "BTW-UK Trikers is a neutral trike association and a family for trikers. Its purpose is to unite trikers and help provide information concerning trikes and triking. Membership is open to anyone interested in trikes or triking. You do not need to own a trike.",
            "url": "http://www.btw-uk.co.uk/"
        },
        {
            "name": "Patches UK",
            "image": "images/sponsors/patches-uk.jpg",
            "description": "Patches UK creates personalised patches and gifts, supplying pin badges and more. Their aim is to provide items you cannot find in shops, with a growing range of quirky designs.",
            "url": "https://www.patchesuk.co.uk/"
        },
        {
            "name": "Carpets Refreshed",
            "image": "images/sponsors/carpets-refreshed.png",
            "description": "Professional carpet cleaning service covering Bedford, Milton Keynes, Northampton, Luton and surrounding areas. Cleans carpets, rugs, mattresses, sofas and holiday homes. Over 12 years experience. Dry within 30 minutes.",
            "url": "https://carpetsrefreshed.co.uk/"
        },
        {
            "name": "Become a Sponsor",
            "image": "images/sponsors/become-sponsor.jpg",
            "description": "Help keep B.T.W Radio going by becoming a sponsor. Affordable packages are available. Contact us for more details.",
            "url": null
        },
        {
            "name": "Charity",
            "image": "images/sponsors/charity.jpg",
            "description": "B.T.W Radio is a non-profit station that helps charities every month. By becoming a sponsor, you help us support them. B.T.W Radio is for everyone, not just bikers.",
            "url": null
        }
    ]
};

const Sponsors = () => {

    return (
        <section className="sponsors-pg-sc">
            <div className="container-fluid ps-5 pe-5">
                <div className="row">
                    <div className="col-md-12">
                        <div className="shedule-head">
                            <div className="un-head wow bounceInUp">
                                <h3>OUR SPONSORS</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row wow slideInLeft">
                    {
                        sponsorsData.sponsors.map((sponsor, index) => (
                            <div key={index} className="col-md-6 col-lg-4">
                                <div className="sponsor-card">
                                    <div className="sponsor-image">
                                        {sponsor.url ? (
                                            <a href={sponsor.url} target="_blank" rel="noopener noreferrer">
                                                <img src={sponsor.image} alt={sponsor.name} />
                                            </a>
                                        ) : (
                                            <img src={sponsor.image} alt={sponsor.name} />
                                        )}
                                    </div>
                                    <div className="sponsor-content">
                                        {sponsor.url ? (
                                            <a href={sponsor.url} target="_blank" rel="noopener noreferrer">
                                                <h6>{sponsor.name}</h6>
                                            </a>
                                        ) : (
                                            <h6>{sponsor.name}</h6>
                                        )}
                                        <p>{sponsor.description}</p>
                                        {sponsor.url && (
                                            <a href={sponsor.url} target="_blank" rel="noopener noreferrer" className="sponsor-link">
                                                Visit Website <i className="fas fa-external-link-alt"></i>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    )
}

export default Sponsors
